import { Text } from "../Text"
import styles from "./BarChartLegend.module.css"
import { defaultColors } from "./defaultColors"

interface BarChartLegendProps {
  keyLabels: string[]
  colors?: string[]
}

export function BarChartLegend(props: BarChartLegendProps) {
  const { keyLabels, colors = defaultColors } = props

  return (
    <div className={styles.legend}>
      {keyLabels.map((keyLabel, index) => (
        <div key={keyLabel} className={styles.legendItem}>
          <div
            className={styles.legendColor}
            style={{ backgroundColor: colors[index % colors.length] }}
          />
          <Text variant="smallBold">{keyLabel}</Text>
        </div>
      ))}
    </div>
  )
}
